module.exports = __webpack_public_path__ + "static/planche-6ed1e11931ba4bcb6436ff62ab8dbffe.jpg";